import { UnitType } from '@exodus/currency'

const name = 'cosmos'
const displayName = 'Cosmos'
const ticker = 'ATOM'
const displayTicker = 'ATOM'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#C6B6F3'
const gradientColors = ['#6F7390', '#383C58']
const gradientCoords = { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' }
const chainBadgeColors = gradientColors

const units = {
  uatom: 0,
  ATOM: 6,
}
const currency = UnitType.create(units)

const assetType = 'COSMOS_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://www.mintscan.io/cosmos/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://www.mintscan.io/cosmos/txs/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Cosmos is an ecosystem of interoperable blockchains. The end goal is to create an Internet of Blockchains, a network of sovereign blockchains able to communicate with each other in a decentralized way.',
  reddit: 'https://reddit.com/r/cosmosnetwork',
  twitter: 'https://twitter.com/cosmos',
  website: 'https://cosmos.network/',
  telegram: 'https://t.me/cosmosproject',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  baseDenom: 'uatom',
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
